<template>
    <v-form ref="form" @submit="submit" v-model="formValid" class="call-configs">
        <!-- Header title -->
        <div class="title-config">
            <div class="title">{{ $f.tc('advancedSettings') }}</div>
            <div style="display: flex; align-items: center">
                <div class="btn-custom" @click="submit">{{ $f.tc('save') }}</div>
            </div>
        </div>

        <!-- Content -->
        <div class="fci-scrollbar config-content">
            <!-- Voice profile -->
            <div class="child-title mb-8" style="padding: 0!important;">
                {{ $f.tc('actionCodeMapping') }}
                <v-switch style="margin-left: 10px"
                          color="#0052cc"
                          v-model="enableMappingActionCode"
                          hide-details
                ></v-switch>
            </div>
            <div class="mb-20" v-if="enableMappingActionCode">
                <div class="" v-for="(item, index) in actionCodeMapping" :key="item.key">
                    <div class="mr-10 label" style="width: 170px">{{ actionCodeMapping[index].key }}</div>
                    <v-text-field
                        v-model="actionCodeMapping[index].value"
                        single-line
                        class="input-custom"
                        :rules="[formRules.ruleRequired]"
                        ref="ActionCodeMappingVal"
                        spellcheck="false"
                    ></v-text-field>
                </div>
            </div>
            <div class="child-title mb-8" style="padding: 0!important;">
                {{ $f.tc('phoneNumberCallLimit') }}
                <v-switch style="margin-left: 10px"
                          color="#0052cc"
                          v-model="enableLimitCallPhoneNumber"
                          hide-details
                ></v-switch>
            </div>
            <div class="mb-20" v-if="enableLimitCallPhoneNumber">
                <v-text-field
                    outlined
                    type="number"
                    v-model="limitCallPhoneNumber"
                    :min="0"
                    :rules="[formRules.ruleRequired, formRules.rulePositiveNumber]"
                    class="input-custom input-number"
                ></v-text-field>
            </div>
            <div class="child-title mb-8" style="padding: 0!important;">
                {{ $f.tc('hide') }} {{ $t('customerProperties') }}
                <v-switch style="margin-left: 10px"
                          color="#0052cc"
                          v-model="enableHiddenCustomerProperties"
                          hide-details
                ></v-switch>
            </div>
            <div v-if="enableHiddenCustomerProperties">
                <div class="centerY">
                    <v-autocomplete
                        ref="NewEmailConfig"
                        :items="customerPropertiesList"
                        v-model="addCustomerProperties"
                        class="input-custom mr-6"
                        spellcheck="false"
                        hide-details
                        item-text="description"
                        item-value="name"
                    ></v-autocomplete>
                    <div class="btn-custom" @click="addHiddenCustomerProperties(addCustomerProperties)">
                        {{ $f.tc('addNew') }}
                    </div>
                </div>
                <!--List hidden customer properties-->
                <div class="monitoring-bar centerY scrollbar-horizontal-thin">
                    <div class="centerY mr-6" style="gap: 6px;flex-wrap: wrap"
                         v-if="hiddenCustomerProperties && hiddenCustomerProperties.split(';').length > 0">
                        <div class="tag-item centerXY"
                             v-for="monitoringItem in hiddenCustomerProperties.split(';')"
                             :key="monitoringItem">
                            {{ monitoringItem }}
                            <img src="/img/debug/close-circle.svg" alt="icon-close" v-if="monitoringItem"
                                 @click="deleteHiddenCustomerProperties(monitoringItem)">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </v-form>
</template>

<script>
import FormMixin from "@/modules/fptai/mixins/FormMixin";
import {mapState} from "vuex";
import BaseConfig from "@/views/Campaign/Form/Step4/BaseConfig";
import lodash from "lodash";
import CampaignService from "@/services/campaign.service";

const actionCodeMappingDefault = [{
    key: "data_collection_key",
    value: ""
}]
export default {
    name: "AdvancedSetting",
    mixins: [FormMixin],
    extends: BaseConfig,
    data() {
        return {
            enableMappingActionCode: false,
            actionCodeMapping: this.$utils.cloneObject(actionCodeMappingDefault),
            oldActionCodeMapping: '',
            enableLimitCallPhoneNumber: false,
            limitCallPhoneNumber: -1,
            oldLimitCallPhoneNumber: -1,
            enableHiddenCustomerProperties: false,
            customerPropertiesList: [],
            hiddenCustomerProperties: '',
            oldHiddenCustomerProperties: '',
            addCustomerProperties: ''
        }
    },
    computed: {
        ...mapState({
            campaignConfig: state => state.campaign.campaignConfig,
        }),
    },
    mounted() {
        if (!this.campaignConfig) {
            this.$appService.showLoading()
            this.getActionCodeMapping().finally(this.$appService.hideLoading)
        }
        CampaignService.getCustomerProperties(this.campaign).then((res) => {
            this.customerPropertiesList = res.data
        })
    },
    methods: {
        submitValidForm() {
            let newMapping = {}
            this.actionCodeMapping.forEach(i => {
                newMapping[i.key] = i.value
            })

            if (!this.enableMappingActionCode) {
                newMapping = {}
            }

            let newLimitCall = -1
            if (this.enableLimitCallPhoneNumber) {
                newLimitCall = this.limitCallPhoneNumber
            }

            let newHiddenCustomerProperties = ''
            if (this.enableHiddenCustomerProperties) {
                newHiddenCustomerProperties = this.hiddenCustomerProperties
            }

            if (!lodash.isEqual(newMapping, this.oldActionCodeMapping) || this.oldLimitCallPhoneNumber !== newLimitCall || this.oldHiddenCustomerProperties !== newHiddenCustomerProperties) {
                this.updateActionCodeMapping(newMapping, newLimitCall, newHiddenCustomerProperties)
            }
        },
        updateActionCodeMapping(newMapping, newLimitCall, newHiddenProperties) {
            this.$appService.showLoading()
            if (newMapping['data_collection_key']) {
                newMapping['data_collection_key'] = newMapping['data_collection_key'].trim()
            }
            let dataMapping = JSON.stringify(newMapping) === '{}' ? '' : JSON.stringify(newMapping)
            CampaignService.saveConfig(this.campaign, {
                'action_code_mapping': dataMapping,
                'phone_number_call_limit': newLimitCall,
                'hidden_customer_properties': newHiddenProperties
            }).then(() => {
                this.getActionCodeMapping().finally(() => {
                    this.$appService.hideLoading()
                    this.$appService.toastSuccess(`${this.$f.tc('update')} ${this.$t('successful')}`)
                })
            })
        },
        getActionCodeMapping() {
            return this.$store.dispatch(this.$actionTypes.campaign.GET_CAMPAIGN_CONFIG, this.campaign.id)
        },
        addHiddenCustomerProperties(value) {
            if (!value) {
                return
            }
            // validate duplicate
            if (this.hiddenCustomerProperties.split(';').includes(value)) {
                this.$appService.toastError(this.$f.tc('formRules.fieldDuplicate'))
                return
            }
            if (this.hiddenCustomerProperties === '') {
                this.hiddenCustomerProperties = value
            } else {
                this.hiddenCustomerProperties = this.hiddenCustomerProperties + ';' + value
            }
        },
        deleteHiddenCustomerProperties(email) {
            let arrEmail = this.hiddenCustomerProperties.split(';')
            arrEmail = arrEmail.filter(item => item !== email)
            let newArrayEmail = ''
            if (arrEmail.length === 1) {
                newArrayEmail = arrEmail[0]
            } else {
                for (let e of arrEmail) {
                    newArrayEmail = newArrayEmail + e + ';'
                }
                newArrayEmail = newArrayEmail.slice(0, -1)
            }
            this.hiddenCustomerProperties = newArrayEmail
        },
    },
    watch: {
        campaignConfig: {
            deep: true,
            handler: function (newVal) {
                let mappingData = newVal['action_code_mapping']
                let limitCallPhoneNumber = newVal['phone_number_call_limit']
                let hiddenCustomerProperties = newVal['hidden_customer_properties']
                this.enableMappingActionCode = !!mappingData
                this.enableLimitCallPhoneNumber = limitCallPhoneNumber > -1
                this.enableHiddenCustomerProperties = hiddenCustomerProperties !== ''
                this.oldActionCodeMapping = newVal && mappingData ? JSON.parse(mappingData) : {}
                this.oldLimitCallPhoneNumber = newVal && limitCallPhoneNumber ? limitCallPhoneNumber : -1
                this.oldHiddenCustomerProperties = newVal && hiddenCustomerProperties ? hiddenCustomerProperties : ''
                let dataConvert = []
                Object.keys(this.oldActionCodeMapping).forEach(key => {
                    dataConvert.push({
                        key: key,
                        value: this.oldActionCodeMapping[key]
                    })
                })
                this.actionCodeMapping = dataConvert.length > 0 ? dataConvert : this.$utils.cloneObject(actionCodeMappingDefault)
                this.limitCallPhoneNumber = this.oldLimitCallPhoneNumber === -1 ? 3 : this.oldLimitCallPhoneNumber
                this.hiddenCustomerProperties = this.oldHiddenCustomerProperties
            }
        },
    }
}
</script>

<style scoped lang="scss">
::v-deep {
    .v-text-field {
        padding-top: 0 !important;
        margin-top: 0 !important;
    }

    .v-text-field__details {
        position: absolute;
        right: 12px;
        top: 8px;
    }

    .v-select {
        .v-text-field__details {
            right: 40px !important;
            top: 7px;
        }

        .v-input__slot {
            padding: 6px 3px 6px 12px;
        }
    }

    .v-input--selection-controls {
        margin-top: 0 !important;
        padding-top: 0 !important;
    }

    .v-input__control {
        width: 100%;
    }
}

.config-content {
    padding: 20px;
}

.child-title {
    font-size: 16px;
    font-family: 'open sans bold', serif;
    font-weight: 700;
    padding-top: 20px;
    margin-bottom: 6px;
    display: flex;
    align-items: center;
}

.title-config {
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 48px;
    padding: 0 20px;
    border-bottom: 1px solid #E4EDFA;
}

.label {
    font-family: "open sans semi", serif;
    margin-bottom: 6px;
    font-size: 13px;
}

.input-custom {
    position: relative;

    ::v-deep {
        .v-input__slot {
            height: 32px;
            background: #FFFFFF;
            border-radius: 5px;
            border: 1px solid #D9D9D9;
            outline: none;
            font-size: 14px;
            padding: 6px 12px;
            margin: 0;
            display: flex;
            align-items: center;

            &:before, &:after {
                border: none !important;
            }
        }

        .v-text-field__details {
            right: 12px;
        }
    }
}

.monitoring-bar {
    padding: 8px 0;
    background: #FFFFFF;
    width: 100%;
    overflow-x: auto;
    overflow-y: hidden;

    .tag-item {
        padding: 0 6px 0 8px;
        height: 25px;
        line-height: 25px;
        background: #EAEEFF;
        color: #0052CC;
        border-radius: 4px;
        font-size: 13px;
        font-family: "open sans", serif;

        img {
            cursor: pointer;
            width: 18px;
            margin-left: 3px;
        }
    }
}

.btn-add-monitoring {
    padding: 3px 8px;
    cursor: pointer;
    border-radius: 5px;
    justify-content: center;
    color: #818181;
    white-space: nowrap;
    font-family: "open sans", serif;
    font-size: 13px;
    background: #EFEFEF;

    &:hover {
        background: #0052CC;
        color: #FFFFFF;
        transition: 0.3s;

        .icon-add-monitoring {
            background-image: url("/img/debug/add-box_white.svg");
        }
    }
}
</style>
